<template>
  <b-container fluid class="ps-0">
    <b-row>
      <b-col lg="3" xl="2" xxl="2" class="staticleftsidebar">
        <LeftBar masterheading="Store Master" pagename="StoreMasterDetails" @clickdata="" v-model="datas"
          :storestatus="true" :listed="sidebardata" listtype="Stores">
        </LeftBar>
        <a class="back-btn" @click="$router.push({ path: '/StoreMaster' })">
          <img alt="Vue logo" class="back" src="../../../../../../assets/Img/icons/backtoright.svg" width="125"
            height="125" />
        </a>
      </b-col>
      <b-col lg="9" xl="10" xxl="10">
        <b-container fluid>
          <!-- {{ datas }}a -->
          <b-row>
            <b-col class="my-3">
              <p class="light-txt">{{ datas.Code }}</p>
              <!-- <Headerlayout :headertext="datas.Name"></Headerlayout> -->
              <p class="common-heading1">{{ datas.Name }}</p>
            </b-col>
          </b-row>
          <div class="overall-bg p-0 header-top">
            <section>
              <b-container class="storetabdetails">
                <TabView class="tabview-custom transaction-tabs position-relative" v-model:activeIndex="clases"
                  ref="tabview4" scrollable @keyup.enter="handleKeyDown">
                  <TabPanel v-for="(tab, index) in TabArray" :key="index">
                    <!-- <div @click="scrollToPreviousTab" class="detailsleftbtn detailsbtn">
                      <i class="pi pi-chevron-left"></i>
                    </div> -->
                    <template #header>
                      <div class="d-flex align-items-center" @click="TabClick(tab, index), TabGetIndex(index)">
                        <img :src="tab.Image" class="DetailsIcon" />
                        <span style="padding: 0px 7px">{{
                          $t(`${tab["Path"]}`)
                        }}</span>
                      </div>
                    </template>
                    <!-- <div @click="scrollToNextTab" class="detailsrightbtn detailsbtn">
                      <i class="pi pi-chevron-right"></i>
                    </div> -->
                    <!-- {{ activeTabIndex }} -->
                    <!-- {{ index }} -->

                    <div v-if="activeTabIndex == index">
                      <!-- {{tab}} -->
                      <component :is="tab.FixedHref" :propsParams="paramValues" :FunctionRights="functionRights"
                        :Addstatus="false" :tstatus="false" @StoreCode="storeCode" :IsAddButton="false" />
                    </div>
                  </TabPanel>
                </TabView>


              </b-container>
            </section>
          </div>
          <!-- <b-row>
            <b-col>
              <TabView class="tabview-custom transaction-tabs" :scrollable="true">
                <TabPanel>
                  <template #header>
                    <i class="pi pi-align-left"></i>
                    <span style="padding-left: 2px;">Details</span>
                  </template>
                  <div>
                    <Details />
                  </div>
                </TabPanel>
                <TabPanel>
                  <template #header>
                    <i class="pi pi-shopping-bag"></i>
                    <span style="padding-left: 2px;">Items</span>
                  </template>
                  <div>
                    <ItemDetailsTableview :propsParams.Id="datas.Id" />
                  </div>
                </TabPanel>
                <TabPanel v-if="status == '1'">
                  <template #header>
                    <i class="pi pi-users"></i>
                    <span style="padding-left: 2px;">PI</span>
                  </template>
                  <div>
                    <PITable />
                  </div>
                </TabPanel>
                <TabPanel v-if="status == '1'">
                  <template #header>
                    <i class="pi pi-users"></i>
                    <span style="padding-left: 2px;">PO</span>
                  </template>
                  <div>
                    <POTableview :propsParams="paramValues" :FunctionRights="functionRights" />
                  </div>
                </TabPanel>
                <TabPanel v-if="status == '1'">
                  <template #header>
                    <i class="pi pi-users"></i>
                    <span style="padding-left: 2px;">PO Ammendment</span>
                  </template>
                  <div>
                    <POAmmendmentTableview :propsParams="paramValues" :FunctionRights="functionRights" />
                  </div>
                </TabPanel>
                <TabPanel v-if="status == '1'">
                  <template #header>
                    <i class="pi pi-users"></i>
                    <span style="padding-left: 2px;">GRN</span>
                  </template>
                  <div>
                    <TabPanel v-if="status == '1'">
                      <template #header>
                        <span style="padding-left: 2px;">GRN</span>
                      </template>
                      <div>
                        <GrnTable :propsParams.Id="datas.Id" />
                      </div>
                    </TabPanel>
                    <! <TabView class="tabview-custom my-3" ref="tabview4" :scrollable="true">
                      <TabPanel v-if="status == '1'">
                        <template #header>
                          <span>GRN</span>
                        </template>
                        <div>

                          <GrnTable :propsParams.Id="Id" />
                        </div>
                      </TabPanel>
                      <TabPanel v-if="status == '1'">
                        <template #header>
                          <span>Returns</span>
                        </template>
                        <div>
                          <GrnReturnTableview :propsParams.Id="Id" />
                        </div>
                      </TabPanel>
                    </TabView> --
                  </div>
                </TabPanel>
                <TabPanel>
                  <template #header>
                    <i class="pi pi-users"></i>
                    <span style="padding-left: 2px;">User</span>
                  </template>
                  <div>
                    <UserTableView />
                  </div>
                </TabPanel>
                <TabPanel v-if="status == '2'">
                  <template #header>
                    <i class="pi pi-users"></i>
                    <span style="padding-left: 2px;">Inbound Request</span>
                  </template>
                  <div>
                    <InboundRequestTableview :propsParams="datas.Id" />
                  </div>
                </TabPanel>
                <TabPanel v-if="status == '2'">
                  <template #header>
                    <i class="pi pi-users"></i>
                    <span style="padding-left: 2px;">Outbound Issue</span>
                  </template>
                  <div>
                    <OutBoundIssueTableView :propsParams="datas.Id" />
                  </div>
                </TabPanel>
                <TabPanel v-if="status == '2' || status == '3'">
                  <template #header>
                    <i class="pi pi-users"></i>
                    <span style="padding-left: 2px;">Outbound Request</span>
                  </template>
                  <div>
                    <OutboundRequestTableview :propsParams="datas.Id" />
                  </div>
                </TabPanel>
                <TabPanel v-if="status == '2' || status == '3'">
                  <template #header>
                    <i class="pi pi-users"></i>
                    <span style="padding-left: 2px;">Inbound Issue</span>
                  </template>
                  <div>
                    <InBoundIssueTableView :propsParams="datas.Id" />
                  </div>
                </TabPanel>
                <TabPanel>
                  <template #header>
                    <i class="pi pi-users"></i>
                    <span style="padding-left: 2px;">Documents</span>
                  </template>
                  <div>
                    <ItemDetailsDocumentsTableView />
                  </div>
                </TabPanel>

                <TabPanel>
                  <template #header>
                    <i class="pi pi-save"></i>
                    <span style="padding-left: 2px;">Item Category</span>
                  </template>
                  <div>
                    <ItemStoreMappingtable :storeid="datas.Id" :tstatus="true" />
                  </div>
                </TabPanel>
                <TabPanel>
                  <template #header>
                    <i class="pi pi-users"></i>
                    <span style="padding-left: 2px;">Logs</span>
                  </template>
                  <div>
                    <Log />
                  </div>
                </TabPanel>
              </TabView>
            </b-col>
          </b-row> -->
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script lang="ts">
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import { defineComponent, ref, computed, onMounted, watch } from "vue";
import LeftBar from "../../../../../../modules/Inventory/components/MasterDetails/LeftSideBar.vue";
import Details from "../../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import MemberDetails from "../../../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";
// import Rightsidebar from '../../../../modules/Inventory/components/Sidebar/RightSidebar/ItemDetailsSidebar.vue'
import Log from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/Log.vue";
import { useRoute } from "vue-router";
import POTableview from "../../../../../../modules/Inventory/pages/Transaction/PurchaseOrder/POTable.vue";
import RequestTable from "../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/RequestTable.vue";
import PITable from "../../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
// import IssueTable from "../../../../../../modules/Inventory/pages/Transaction/Stockout/issuereturn/ItemIssueTable.vue";
import GrnTable from "../../../../../../modules/Inventory/pages/Transaction/stockin/grn/GrnTable.vue";
import PurchaseIndentTableVue from "../../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
// import POAmmendmentTableview from "../../../../../../modules/Inventory/pages/Transaction/poammendment/POAmmendmentTableview.vue";
import POAmmendmentTableview from "../../../../../../modules/Inventory/pages/Transaction/POAmmendment/POAmmendmentTableview.vue";
// import ItemDetailsTableview from "../../../../../../modules/Inventory/pages/Masters/Items/ItemMaster/DetailsTableview.vue";
import ItemDetailsTableview from "../../../../../../modules/Inventory/pages/Masters/Items/ItemMaster/DetailsTableview.vue";
import MastersService from "../../../../Service/MastersService";

import QuotesTableview from "../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/quotes/QuotesTableview.vue";
import storetab from "../../../../../../modules/Inventory/pages/Masters/Stores/StoreMaster/StoreTab/mainstore.vue";
import ItemStoreMappingtable from "../../../Masters/Items/StoreMappingItemCategory/ItemStoreMappingTblview.vue";
import commonservice from "../../../../Service/StoreService";
import GrnReturnTableview from "../../../../../../modules/Inventory/pages/Transaction/StockOut/grnreturn/GrnReturnTableview.vue";
import ItemDetailsDocumentsTableView from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ItemDetailsDocumentsTableView.vue";
import StoreCategoryMappingTblview from "../../../../../../modules/Inventory/pages/Masters/ItemCategory/StoreCategoryMapping/StoreCategoryMappingTblview.vue";

import ConsumptionTable from "../../../../../../modules/Inventory/pages/Transaction/StockOut/consumption/ConsumptionTable.vue";
import InboundRequestTableview from "../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/inboundrequest/InboundRequestTableview.vue";
import OutboundRequestTableview from "../../../../pages/Transaction/stockwithoutaffect/Request/outboundrequest/OutboundRequestTableview.vue";
import InBoundIssueTableView from "../../../../../../modules/Inventory/pages/Transaction/stockin/issue/InBoundIssue/InBoundIssueTableView.vue";
import OutBoundIssueTableView from "../../../../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/OutBoundIssue/OutBoundIssueTableView.vue";
import UserTableView from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ItemDetailsUserTableView.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import { useInventoryStore } from "../../../../../../modules/Inventory/stores/Index";
import Users from "../../../../../../modules/Inventory/components/MasterDetails/Users.vue";
import DetailsTableview from "../../../../../../modules/Inventory/pages/Masters/Items/ItemMaster/DetailsTableview.vue";
import Documents from "../../../../../../modules/Inventory/components/MasterDetails/Documentation.vue";

export default defineComponent({
  components: {
    PITable,
    ConsumptionTable,
    InboundRequestTableview,
    OutboundRequestTableview,
    InBoundIssueTableView,
    OutBoundIssueTableView,
    GrnReturnTableview,
    ItemStoreMappingtable,
    QuotesTableview,
    ItemDetailsTableview,
    POAmmendmentTableview,
    POTableview,
    LeftBar,
    Details,
    MemberDetails,
    DetailsTableview,
    // Rightsidebar,
    Log,
    Headerlayout,
    PurchaseIndentTableVue,
    RequestTable,
    // IssueTable,
    GrnTable,
    storetab,
    ItemDetailsDocumentsTableView,
    UserTableView,
    Loader,
    Users,
    Documents,
    StoreCategoryMappingTblview
  },
  props: {
    showDetailsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },
    showItemsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },

  },
  setup() {
    const route = useRoute();
    const loading = ref(false);

    let datas = ref({
      Id: ref(),
      Name: "",
      Code: "",
    });
    let status = computed(() => {
      // alert(route.query.storeType)
      return route.query.storeType;
    });
    // const paramValue = computed(() => {
    //   return route.query.param as string;
    // });
    const paramValues = ref({
      Id: "",
      Type: "",
      status: 0,
      storename: "",
      storebranchmapid: 0,
    });
    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    // const Type = computed(() => {
    //     return route.query.Type as string;
    // });
    // const Iddata = computed(() => {
    //     return route.query.Id as string;
    // });

    let functionRights = ref({
      Create: false,
      Update: false,
      Read: true,
      Delete: false,
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
      EntityId: 0,
    });
    watch(
      () => route.query.Id,
      (newVal: any) => {
        debugger;
        // alert('newVal')
        paramValues.value.Id = newVal;
        paramValues.value.Type = route.query.Type as string;
      }
    );
    onMounted(() => {
      paramValues.value.Id = String(route.query.Id);
      paramValues.value.Type = route.query.Type as string;
      LoadMenus()
      IsShow();
    });
    const sidebardata = ref([]);
    async function IsShow() {
      debugger;
      loading.value = true;
      try {
        let response = await commonservice.getStoreList(
          usersData.OrganizationId,
          usersData.BranchId
        );
        console.log(response["result"]);
        sidebardata.value = response["result"].filter(
          (i1) => i1.IsActive == true
        );
        console.log(sidebardata.value);
        let obj = sidebardata.value.filter(
          (items) => items["Id"] == paramValues.value.Id
        );

        datas.value.Name = obj[0]["Name"];
        datas.value.Code = obj[0]["Code"];
        datas.value.Id = obj[0]["Id"];

        loading.value = false;

        // const oldKey = 'Name';
        // const newKey = 'Name';
        // sidebardata.value = response["result"].map((item) => {
        //   const newItem = { ...item, [newKey]: item[oldKey] };
        //   delete newItem[oldKey];
        //   return newItem;
        // })
        // alert(sidebardata.value[0]['Name1'])
        // console.log(items.value);
      } catch (error) {
        loading.value = false;
        console.log(error);
      }

    }

    const clases = ref(0);
    const inventoryStore = useInventoryStore();

    let menuarray: any = ref([]);

    let TabArray: any = ref([]);



    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //
    watch(
      () => inventoryStore.MenuTab,
      (newVal: any) => {
        debugger
        if (inventoryStore.MenuTab != null) {
          let WatchEntityId = {
            EntityId: (inventoryStore.MenuTab == 3048 || inventoryStore.MenuTab == 3049) ? 3035 : inventoryStore.MenuTab
          }
          let index = 0
          if (inventoryStore.MenuTab == 3048 || inventoryStore.MenuTab == 3049) {
            inventoryStore.SubTab = inventoryStore.MenuTab
            index = 3
          }
          else if (inventoryStore.MenuTab == 3044) {
            index = 7
          }
          else if (inventoryStore.MenuTab == 3039) {
            index = 8
          }
          else if (inventoryStore.MenuTab == 3069) {
            index = 5
          }
          TabClick(WatchEntityId, index)
          TabGetIndex(index)
        }
      }
    );
    watch(
      () => route.query.Id,
      (newVal: any) => {
        debugger;
        paramValues.value.Id = newVal;
        paramValues.value.Type = route.query.Type as string;
        paramValues.value.status = Number(route.query.storeType);
        paramValues.value.storename = route.query.storename as string;
        paramValues.value.storebranchmapid = Number(
          route.query.storebranchmapid
        );
        LoadMenus();

        clases.value = 0;
        let TabIndexval = localStorage.getItem("TabIndex");
        let TabIndexvalDataData;
        if (TabIndexval !== null) {
          TabIndexvalDataData = JSON.parse(TabIndexval);
        }
        // alert(TabIndexvalDataData.Indexval)
        clases.value = TabIndexvalDataData.Indexval;
        activeTabIndex.value = TabIndexvalDataData.Indexval;

        // alert(activeTabIndex.value)
      }
    );
    let activeTabIndex = ref();
    onMounted(() => {
      paramValues.value.Id = String(route.query.Id);
      paramValues.value.Type = route.query.Type as string;
      paramValues.value.status = Number(route.query.storeType);
      paramValues.value.storename = route.query.storename as string;
      paramValues.value.storebranchmapid = Number(route.query.storebranchmapid);
      LoadMenus();
      // TabIndex
      let TabIndexval = localStorage.getItem("TabIndex");
      let TabIndexvalDataData;
      if (TabIndexval !== null) {
        TabIndexvalDataData = JSON.parse(TabIndexval);
      }
      clases.value = TabIndexvalDataData.Indexval;
      activeTabIndex.value = TabIndexvalDataData.Indexval;

    });

    async function LoadMenus() {
      debugger;
      let response = await MastersService.GetMenus(
        9,
        rolesData.RoleId,
        usersData.OrganizationId
      );
      console.log("MenuListStoreTabDetails", response["result"]);
      menuarray.value = response["result"];
      debugger
      BindTabsByStore(menuarray.value);
    }
    function BindTabsByStore(MenuArray) {
      debugger;
      TabArray.value = MenuArray.filter((item) =>
        item.StoreRights.split(",").includes(route.query.storeType)
      );
      console.log(route.query.storeType);
      console.log(TabArray.value);

      if (TabArray.value.length > 0) {
        let TabIndexval = localStorage.getItem("TabIndex");
        let TabIndexvalDataData;
        if (TabIndexval !== null) {
          TabIndexvalDataData = JSON.parse(TabIndexval);
        }
        if (clases.value !== 0) {
          TabIndexvalDataData.Indexval = clases.value;
        } else {
          TabIndexvalDataData.Indexval = clases.value;
        }
        console.log("Tabarray", TabArray.value);
        TabClick(
          TabArray.value[TabIndexvalDataData.Indexval],
          TabIndexvalDataData.Indexval
        );
      }
    }


    const handleKeyDown = (event: KeyboardEvent) => {
      debugger;
      if (event.key === "ArrowLeft" && clases.value > 0) {
        clases.value--; // Move to the previous tab on left arrow press
      } else if (
        event.key === "ArrowRight" &&
        clases.value < TabArray.length - 1
      ) {
        clases.value++; // Move to the next tab on right arrow press
      }
      activeTabIndex.value = clases.value;
    };
    function TabGetIndex(index) {
      activeTabIndex.value = index;
      clases.value = index;
    }
    async function TabClick(SubMenuDetails, index) {
      debugger;
      console.log("SubMenuEntityId", SubMenuDetails.EntityId);
      let InstantEntityId = {
        EntityId: SubMenuDetails.EntityId,
      };
      localStorage.removeItem("EntityData");
      localStorage.setItem("EntityData", JSON.stringify(InstantEntityId));

      let TabIndex = {
        Indexval: index,
      };
      localStorage.removeItem("TabIndex");
      localStorage.setItem("TabIndex", JSON.stringify(TabIndex));


      localStorage.removeItem("RequestSubTabIndex");
      localStorage.setItem("RequestSubTabIndex", JSON.stringify(TabIndex));
      const response = await MastersService.CheckMenuRights(
        InstantEntityId.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      let Rights = ref({
        Create: false,
        Update: false,
        Read: false,
        Delete: false,
      });

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          functionRights.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          functionRights.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          functionRights.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          functionRights.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      functionRights.value.EntityId = InstantEntityId.EntityId;
      functionRights.value.Create = Rights.value.Create;
      functionRights.value.Update = Rights.value.Update;
      functionRights.value.Read = Rights.value.Read;
      functionRights.value.Delete = Rights.value.Delete;
    }

    function scrollToPreviousTab() {
      clases.value = 0;
      activeTabIndex.value = 0;
    }

    function scrollToNextTab() {
      clases.value = TabArray.value.length - 1;
      activeTabIndex.value = TabArray.value.length - 1;
    }
    function isClear() {
    }
    let StoreCode = ref();

    const storeCode = (data) => {
      StoreCode.value = data;
    };

    return {
      storeCode,
      isClear,
      scrollToPreviousTab,
      scrollToNextTab,
      clases,
      status,
      paramValues,
      menuarray,
      TabClick,
      TabGetIndex,
      functionRights,
      TabArray,
      activeTabIndex,
      handleKeyDown,

      IsShow,
      datas,
      sidebardata,
      loading,
    };
  },
});
</script>

<style lang="scss">
.p-tabview-header span {
  white-space: nowrap;
}

.tabview-custom {
  width: 99%;
}

.staticleftsidebar {
  position: sticky !important;
  top: 0;
}
</style>
